import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      rowGap: 12,
    },
  },
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  labelContainer: {},
  label: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19px',
    color: theme.palette.common.black,
  },
  sublabel: {
    fontSize: '16px',
    lineHeight: '19px',
    color: theme.palette.secondary.dark,
  },
  durationContainer: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 8,
    },
  },
  durationField: {
    width: 120,
    height: 40,
    '& input': {
      padding: '14px 8px',
      paddingRight: 0,
    },
    '& .flatsy-text-field__check': {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '80%',
      width: '80%',
    },
  },
  toggleDisable: {
    opacity: 0.5,
  },
  selectField: { minWidth: 160 },
}))
